
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.525 15.591l.684-.683.75.75.107.107.106-.106 1.84-1.84.106-.106-.106-.106-.752-.75.42-.42.75.752.106.106.106-.106 1.84-1.84.106-.106-.106-.106-.751-.751L9.246 8.87c.753.354 1.6.496 2.433.401a4.456 4.456 0 002.673-1.29 4.507 4.507 0 000-6.367l-.106.106.106-.106a4.508 4.508 0 00-6.367 0l.106.106-.106-.106a4.456 4.456 0 00-1.29 2.673c-.095.833.047 1.68.401 2.433l-6.72 6.72-.107.107.106.106 1.938 1.938.106.106.106-.106zM9.15 7.453l-.1-.061-.084.083-2.804 2.805-.106.106.106.106.75.751-.375.375-.75-.75-.107-.107-.106.106L3.69 12.75l-.106.106.106.106.751.751-.375.376-.751-.751-.106-.106-.106.106-.684.683-.474-.474 6.546-6.546.084-.083-.062-.1-.18-.298a3.307 3.307 0 01.49-4.068 3.321 3.321 0 014.691 0 3.321 3.321 0 010 4.692l.106.106-.106-.106a3.307 3.307 0 01-4.068.49l-.297-.181z","fill":"#918A9D"}})])
          )
        }
      }
    